import * as echarts from 'echarts';
import { color, init } from 'echarts';
import chinaJson from '../../../assets/json/china.json'
echarts.registerMap('china', chinaJson);

import { getDevCount, getPoliceCountAlarm, getTypeCount, getProStatus } from "@/api/homePage";

import { getTotalEnergy, getEnergyRanking, getEnergyDistribution, getWaterTrend, getElectricTrend, getGasTrend, getCostPercent } from "@/api/energy";

import Subtitle from "../components/subtitle.vue"
import moment from 'moment';

var option = {
	color: ['#1FBDFF', '#FFC300', '#F7725B', '#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
	grid: {
		top: '13%',
		left: '4%',
		right: '6%',
		bottom: '10%',
		containLabel: true
	},
	tooltip: {
		trigger: 'axis'
	},
	xAxis: {
		type: 'category',
		boundaryGap: false,
		data: []
	},
	yAxis: {
		type: 'value'
	},
	series: [
		{
			data: [],
			type: 'line',
			symbol: "emptyCircle",
			name: '',
			symbolSize: 8,
			areaStyle: {
				color: {
					x: 0, y: 0, x2: 0, y2: 1,
					colorStops: [{
						offset: 0, color: 'rgba(31, 189, 255, 1)' // 0% 处的颜色
					}, {
						offset: 1, color: 'rgba(31, 189, 255, 0)' // 100% 处的颜色
					}],
				}
			}
		}
	]
}
export default {
	name: 'overview',
	components: {
		Subtitle,
	},
	data() {
		return {
			tabPosition: 'month',
			type: '',
			pickerOptions: {//日期选择，快捷选项
				disabledDate(time) {
					return time.getTime() > Date.now() - 8.64e6
					// return time.getTime() > Date.now();
				},
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
			dateValue: [moment().startOf('months').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")],
			timeDefaultShow: '',


			//总能耗
			totalData: [
				{
					imgUrl: require('../../../assets/images/energy/water.png'),
					quantity: 0,
					text: '用水量（t）'
				}, {
					imgUrl: require('../../../assets/images/energy/electricity.png'),
					quantity: 0,
					text: '用电量（kw·h）'
				}, {
					imgUrl: require('../../../assets/images/energy/gas.png'),
					quantity: 0,
					text: '用燃气量（m³）'
				},
			],

			//能耗排行
			active: 'kgce',
			activeName: '综合能耗（kgce）',
			energyArr: [
				{
					id: 'kgce',
					name: '综合能耗',
				}, {
					id: 'water',
					name: '水',
				}, {
					id: 'electricity',
					name: '电',
				}, {
					id: 'gas',
					name: '燃气',
				},
			],
			energyRankingName: [],
			energyRankingData: [],
			comprehensiveRakingVo: [],
			waterRakingVo: [],
			electricRakingVo: [],
			gasRakingVo: [],

			//设备数量
			deviceStateNum: [//设备数量状态
				{
					bgColor: "#00C0FF",
					text: '总设备：',
					count: 0
				}, {
					bgColor: "#03A81B",
					text: '在线：',
					count: 0
				}, {
					bgColor: "#C2C2C2",
					text: '离线：',
					count: 0
				}, {
					bgColor: "#C50000",
					text: '报警：',
					count: 0
				}, {
					bgColor: "#FD964E",
					text: '故障：',
					count: 0
				}, {
					bgColor: "#4E4E4E",
					text: '未激活：',
					count: 0
				},
			],
			deviceCount: [//设备数统计
				{
					imgUrl: require('../../../assets/images/energy/boiler.png'),
					text: '锅炉：',
					count: 0
				}, {
					imgUrl: require('../../../assets/images/energy/water-pump .png'),
					text: '水泵：',
					count: 0
				}, {
					imgUrl: require('../../../assets/images/energy/else.png'),
					text: '其它：',
					count: 0
				},
			],

			//地图信息
			mapData: [
				{ name: '北京', id: "BeiJing", value: 0 },
				{ name: '天津', id: "TianJin", value: 0 },
				{ name: '上海', id: "ShangHai", value: 0 },
				{ name: '重庆', id: "ChongQing", value: 0 },
				{ name: '河北', id: "HeBei", value: 0 },
				{ name: '河南', id: "HeNan", value: 0 },
				{ name: '云南', id: "YunNan", value: 0 },
				{ name: '辽宁', id: "LiaoNing", value: 0 },
				{ name: '黑龙江', id: "HeiLongJiang", value: 0 },
				{ name: '湖南', id: "HuNan", value: 0 },
				{ name: '安徽', id: "AnHui", value: 0 },
				{ name: '山东', id: "ShanDong", value: 0 },
				{ name: '新疆', id: "XinJiang", value: 0 },
				{ name: '江苏', id: "JiangSu", value: 0 },
				{ name: '浙江', id: "ZheJiang", value: 0 },
				{ name: '江西', id: "JiangXi", value: 0 },
				{ name: '湖北', id: "HuBei", value: 0 },
				{ name: '广西', id: "GuangXin", value: 0 },
				{ name: '甘肃', id: "GanSu", value: 0 },
				{ name: '山西', id: "ShanXi", value: 0 },
				{ name: '内蒙古', id: "NeiMengGu", value: 0 },
				{ name: '陕西', id: "ShananXi", value: 0 },
				{ name: '吉林', id: "JiLin", value: 0 },
				{ name: '福建', id: "FuJian", value: 0 },
				{ name: '贵州', id: "GuiZhou", value: 0 },
				{ name: '广东', id: "GuangDong", value: 0 },
				{ name: '青海', id: "QingHai", value: 0 },
				{ name: '西藏', id: "XiZang", value: 0 },
				{ name: '四川', id: "SiChuan", value: 0 },
				{ name: '宁夏', id: "NingXia", value: 0 },
				{ name: '海南', id: "HaiNan", value: 0 },
				{ name: '台湾', id: "TaiWan", value: 0 },
				{ name: '香港', id: "XiangGang", value: 0 },
				{ name: '澳门', id: "AoMen", value: 0 },
				{ name: '南海诸岛', id: "", value: 0 },
				{ name: '散点1', value: 1009, LngAndLat: [113.52, 23.179] },
			],
			geoCoordMap: {},
			mapColor: ['#002278', '#033a9c', '#0d4fb0', '#1862c1', '#2679d3', '#3a8fe2', '#56a6ed', '#76bdf4', '#97d2fa', '#b1e3fe'],
			allNum: [
				{
					text: '总项目数量：',
					count: 0,
					unit: '',
				}, {
					text: '总供热面积：',
					count: 0,
					unit: '（m²）',
				}, {
					text: '综合能耗：',
					count: 0,
					unit: '（kgce）',
				},
			],

			//费用占比
			totleCost: 0,
			costPercentData: [
				{ value: 0, name: '水费用' },
				{ value: 0, name: '电费用' },
				{ value: 0, name: '燃气费用' },
			],

			//水\电\气趋势图
			xAxisDataWater: [],
			seriesDataWater: [],
			xAxisDataElectricity: [],
			seriesDataElectricity: [],
			xAxisDataGas: [],
			seriesDataGas: [],

			//定时刷新
			timer: null,
		}
	},

	computed: {

	},
	watch: {
		active(val) {
			switch (val) {
				case 'kgce':
					this.activeName = '综合能耗（kgce）'
					this.processingEnergyRankingData(this.comprehensiveRakingVo)
					break;
				case 'water':
					this.activeName = '水（t）'
					this.processingEnergyRankingData(this.waterRakingVo)
					break;
				case 'electricity':
					this.activeName = '电（kw·h）'
					this.processingEnergyRankingData(this.electricRakingVo)
					break;
				case 'gas':
					this.activeName = '燃气（m³）'
					this.processingEnergyRankingData(this.gasRakingVo)
					break;
			}
		},
		tabPosition: {
			handler(val) {
				if (val === '') return;
				switch (val) {
					case 'day'://当天
						this.dateValue = [moment().subtract(1, 'days').format("YYYY-MM-DD 00:00:00"), moment().subtract(1, 'days').format("YYYY-MM-DD 23:59:59")]
						break;
					case 'month'://本月
						this.dateValue = [moment().startOf('months').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
						break;
					case 'quarter'://本季度
						this.dateValue = [moment().startOf('quarters').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
						break;
					case 'year'://本年
						this.dateValue = [moment().startOf('year').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]
						break;
				}

				this.type = val
				this.getTotalEnergy()//总能耗
				this.getEnergyRanking()//能耗排行
				this.getEnergyDistribution()//项目综合能耗分布
				this.getCostPercent()//费用占比
				this.getWaterTrend()//水电气趋势图数据
			},
			immediate: true
		},
		// dateValue: {
		// 	handler(val) {
		// 		console.log(val, 555)
		// 		this.timeDefaultShow = new Date();
		// 		this.timeDefaultShow.setMonth(-1)
		// 	},
		// 	immediate: true,
		// }
	},

	created() {
		this.init()
	},

	mounted() {
		// this.timeDefaultShow = new Date();
		// this.timeDefaultShow.setMonth(new Date().getMonth() - 1);
		// console.log(this.timeDefaultShow,1111)
		// console.log(new Date().getMonth(), 22222)
		// console.log(new Date().getMonth()-1,22222)
		// console.log(this.timeDefaultShow.setMonth(12),33333)
	},

	beforeDestroy() {
		clearInterval(this.timer)
	},

	methods: {
		init() {
			this.deviceData()
			this.timer = setInterval(() => { this.deviceData() }, 10000)
		},

		//选择了时间通过时间请求接口
		handleOnChange() {
			this.type = moment(this.dateValue[0]).format("YYYY-MM-DD") + ',' + moment(this.dateValue[1]).format("YYYY-MM-DD")
			this.tabPosition = ''
			this.getTotalEnergy()//总能耗
			this.getEnergyRanking()//能耗排行
			this.getEnergyDistribution()//项目综合能耗分布
			this.getCostPercent()//费用占比
			this.getWaterTrend()//水电气趋势图数据
		},

		//总能耗
		async getTotalEnergy() {
			const res = await getTotalEnergy(this.type)
			if (res.code == 200) {
				res.data.forEach(el => {
					if (el.type === '水') { this.totalData[0].quantity = el.value }
					if (el.type === '电') { this.totalData[1].quantity = el.value }
					if (el.type === '燃气') { this.totalData[2].quantity = el.value }
				})
			}
		},

		//能耗排行
		async getEnergyRanking() {
			const res = await getEnergyRanking(this.type)
			if (res.code == 200) {
				this.comprehensiveRakingVo = res.data.comprehensiveRakingVo
				this.waterRakingVo = res.data.waterRakingVo
				this.electricRakingVo = res.data.electricRakingVo
				this.gasRakingVo = res.data.gasRakingVo
				this.processingEnergyRankingData(this.comprehensiveRakingVo)
			}
		},

		//处理能耗排行数据
		processingEnergyRankingData(data) {
			data.sort((a, b) => { return a.value - b.value })
			this.energyRankingName = []
			this.energyRankingData = []
			data.slice(-10).forEach(el => {
				this.energyRankingName.push(el.name)
				this.energyRankingData.push(el.value)
			})
			this.getRankingListEchart()
		},

		//项目综合能耗分布
		async getEnergyDistribution() {
			const res = await getEnergyDistribution(this.type)
			if (res.code == 200) {
				this.allNum[0].count = res.data.projectNum
				this.allNum[1].count = res.data.areaNum
				this.allNum[2].count = res.data.energyConsumption

				this.mapData = []
				this.geoCoordMap = {}
				res.data.regionalList.forEach(el => {
					this.mapData.push({
						name: el.region_name,
						value: el.singleEnergy,
						projectName: el.project_name
					})
					this.geoCoordMap[el.region_name] = [el.longitude, el.latitude]
				})
				this.getEchartMap()
			}
		},

		//费用占比
		async getCostPercent() {
			const res = await getCostPercent(this.type)
			if (res.code == 200) {
				this.totleCost = res.data.totleCost
				this.costPercentData[0].value = res.data.waterPercent
				this.costPercentData[1].value = res.data.electricPercent
				this.costPercentData[2].value = res.data.gasPercent
				this.costOfEchart()
			}
		},


		//水电气 趋势图数据
		getWaterTrend() {
			getWaterTrend(this.type).then(res => {
				if (res.code == 200) {
					this.xAxisDataWater = []
					this.seriesDataWater = []
					res.data.forEach(el => {
						this.xAxisDataWater.push(this.type === 'year' ? Number(el.time) + '月' : el.time)
						this.seriesDataWater.push(el.value)
					})
					this.waterTrendEchart(option)
				}
			})
			getElectricTrend(this.type).then(res => {
				if (res.code == 200) {
					this.xAxisDataElectricity = []
					this.seriesDataElectricity = []
					res.data.forEach(el => {
						this.xAxisDataElectricity.push(this.type === 'year' ? Number(el.time) + '月' : el.time)
						this.seriesDataElectricity.push(el.value)
					})
					this.electricityTrendEchart(option)
				}
			})
			getGasTrend(this.type).then(res => {
				if (res.code == 200) {
					this.xAxisDataGas = []
					this.seriesDataGas = []
					res.data.forEach(el => {
						this.xAxisDataGas.push(this.type === 'year' ? Number(el.time) + '月' : el.time)
						this.seriesDataGas.push(el.value)
					})
					this.gasTrendEchart(option)
				}
			})
		},

		//中间的地图
		getEchartMap() {
			let that = this
			let convertData = function (data) {
				let res = [];
				for (let i = 0; i < data.length; i++) {
					let geoCoord = that.geoCoordMap[data[i].name];
					if (geoCoord) {
						res.push({
							name: data[i].name,
							value: geoCoord.concat(data[i].value).concat(data[i].projectName),
						});
					}
				}
				return res;
			};

			let formatter = function (params) {
				// return params.name + '<br/>' + params.value[3] + '：' + params.value[2]
				return '项目名称：' + params.value[3] + '<br/>' + '项目能耗：' + params.value[2] + '(kgce)'
			};

			let option = {
				geo: {
					//引入中国的地图
					map: 'china',
					left: 20,
					top: 10,
					right: 20,
					bottom: 10,
					label: {
						normal: {
							show: false  //省份名称
						},
						emphasis: {//鼠标放上 中间字体显示，并且颜色变化
							show: true
						},
					},
					roam: true,
					zoom: 1,
					itemStyle: {
						normal: {
							borderWidth: .5,//区域边框宽度
							borderColor: '#FFF',//区域边框颜色
							areaColor: "#fadb9b",//区域颜色
						},
						emphasis: {
							borderWidth: .2,
							borderColor: '#FFF',
							areaColor: "#17f0cc",//fadb9b
						}
					},
				},

				tooltip: {
					trigger: 'item',
					formatter: formatter,
				},

				//配置属性
				series: [
					{
						name: 'pm2.5',
						type: 'scatter',
						coordinateSystem: 'geo',
						data: convertData(this.mapData),
						encode: {
							value: 2
						},
						symbolSize: function (val) {
							// return val[2] * 5;
							// return val[2];
							return Math.sqrt(val[2]) / 10;
						},
						label: {
							formatter: '{b}',
							position: 'right'
						},

						itemStyle: {
							// color: '#0037ffab'
						},
						emphasis: {
							label: {
								show: true
							}
						}
					},
				]
			};

			let myChart = echarts.init(document.getElementById('echartMap'));
			myChart.setOption(option);
		},

		//设备数量
		deviceData() {
			//总数量
			getDevCount().then(res => {
				if (res.code == 200) {// 总数量
					this.deviceStateNum[0].count = res.data.tolNum
				}
			})
			//在线统计
			getProStatus().then(res1 => {
				if (res1.code == 200) {
					this.deviceStateNum[1].count = res1.data.onlineDevCount //在线
					this.deviceStateNum[2].count = res1.data.offlineDevCount //离线
					this.deviceStateNum[5].count = res1.data.unActiveDevCount //未激活
				}
			})
			//告警设备数
			getPoliceCountAlarm().then(res2 => {
				if (res2.code == 200) {
					this.deviceStateNum[3].count = res2.data
				}
			})
			//设备类型 锅炉 水泵 其他设备
			getTypeCount().then(res3 => {
				if (res3.code == 200) {
					let count = 0
					res3.data.forEach(el => {
						if (el.device_type_name === '锅炉设备') {
							this.deviceCount[0].count = el.count
						} else if (el.device_type_name === '水泵') {
							this.deviceCount[1].count = el.count
						} else {
							count += el.count
						}
					})
					this.deviceCount[2].count = count
				}
			})
		},


		//费用占比
		costOfEchart() {
			let option = {
				color: ['#00B4FF', '#FFC300', '#F7725B'],
				tooltip: {
					trigger: 'item',
					formatter: '{b}：{d}%',
				},
				legend: {
					orient: 'horizontal',
					bottom: '8%',
					data: [
						{
							name: '水费用',
							icon: 'circle',
						}, {
							name: '电费用',
							icon: 'circle',
						}, {
							name: '燃气费用',
							icon: 'circle',
						},
					]
				},
				series: [
					{
						name: '费用占比',
						type: 'pie',
						radius: '50%',
						center: ['50%', '45%'],
						data: this.costPercentData,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						},
						label: {
							show: true,
							formatter: '{b}：{d}%',
							fontSize: 12,
							color: '#999'
						}
					}
				]
			};
			let myChart = echarts.init(document.getElementById('costofEchart'));
			myChart.setOption(option);
		},

		//能耗排行
		getRankingListEchart() {
			let option = {
				color: ['#00D49B', '#00B4FF'],
				grid: {
					top: '5%',
					left: '3%',
					right: '5%',
					bottom: '8%',
					containLabel: true
				},
				tooltip: {
					trigger: 'axis',
					// formatter: '{b} <br /> 设备数量：{c}'
				},
				legend: {
					bottom: '1.5%',
					data: [
						{
							name: this.activeName,
							icon: 'circle',
						}
					]
				},

				xAxis: {
					type: 'value'
				},
				yAxis: {
					type: 'category',
					axisLabel: {
						// width: 100,
						// overflow: 'truncate',
						// ellipsis:'...',
						formatter: function (params) {
							var val = "";
							if (params.length > 8) {
								val = params.substr(0, 8) + '...';
								return val;
							} else {
								return params;
							}
						}
					},
					// data: ['湖南', '湖北', '北京', '重庆', '上海', '西安', '衡水', 'AUG', 'OCT', 'NOV', 'JUN']
					data: this.energyRankingName
				},
				series: [{
					// data: [120, 220, 150, 80, 70, 110, 130, 150, 80, 70, 110, 130],
					name: this.activeName,
					data: this.energyRankingData,
					type: 'bar',
					itemStyle: {
						normal: {
							barBorderRadius: [0, 15, 15, 0]
						}
					},
				}]
			};

			let myChart = echarts.init(document.getElementById('rankingListEchart'));
			myChart.setOption(option);
		},


		//用水趋势图
		waterTrendEchart(option) {
			let xAxisData = ['12-01', '12-02', '12-03', '12-04', '12-05', '12-06', '12-07', '12-08', '12-09', '12-10']
			let seriesData = [3, 4, 5, 8, 12, 15, 19, 22, 28, 35]

			option.color = ['#1FBDFF']
			option.xAxis.data = this.xAxisDataWater
			option.series[0].data = this.seriesDataWater
			option.series[0].name = '水（t）'
			option.series[0].areaStyle.color.colorStops = [{
				offset: 0, color: 'rgba(31, 189, 255, 1)' // 0% 处的颜色
			}, {
				offset: 1, color: 'rgba(31, 189, 255, 0)' // 100% 处的颜色
			}]

			let myChart = echarts.init(document.getElementById('waterEchart'));
			myChart.setOption(option);
		},

		//用电趋势图
		electricityTrendEchart(option) {
			option.color = ['#FFC300']
			option.xAxis.data = this.xAxisDataElectricity
			option.series[0].data = this.seriesDataElectricity
			option.series[0].name = '电（kw·h）'
			option.series[0].areaStyle.color.colorStops = [{
				offset: 0, color: 'rgba(255, 195, 0, 1)' // 0% 处的颜色
			}, {
				offset: 1, color: 'rgba(255, 195, 0, 0)' // 100% 处的颜色
			}]

			let myChart = echarts.init(document.getElementById('electricityEchart'));
			myChart.setOption(option);
		},

		//燃气趋势图
		gasTrendEchart(option) {
			option.color = ['#F7725B']
			option.xAxis.data = this.xAxisDataGas
			option.series[0].data = this.seriesDataGas
			option.series[0].name = '燃气（m³）'
			option.series[0].areaStyle.color.colorStops = [{
				offset: 0, color: 'rgba(247, 114, 91, 1)' // 0% 处的颜色
			}, {
				offset: 1, color: 'rgba(247, 114, 91, 0)' // 100% 处的颜色
			}]

			let myChart = echarts.init(document.getElementById('gasEchart'));
			myChart.setOption(option);
		},
	}
}